import { buildLockedVideo } from './locked-player';
import { buildVideoPlayer } from './video-player';

//
// Loop over all video player placeholders and initialize preview
export default function initializeEmbeddedVideos() {
  var videos = $('div.video-player');

  videos.each(function (index, element) {
    var $this = $(element),
      videoId = $this.data('videoId');

    // Fetch the video's information from the api
    $.get({
      url: '/media/' + videoId,
      dataType: 'json',
    }).done(function (video) {
      if (video.public || currentUser.subscriber) {
        buildVideoPlayer(element, video);
      } else {
        buildLockedVideo(element);
      }
    });
  });
}
